import { withInstall } from '@vuesax-plus/utils'
import _IconsPlus from './src/plus.vue'

export const IconsPlus = withInstall(_IconsPlus)
export default IconsPlus

export * from './src/plus'
